export const formattedMeterNumber = (value?: string | number) => {
	if (!value) {
		return '';
	}

	return value.toString().replace(/^0+/, '');
};
